import { ApiError } from '@/lib/api';
export interface ParentCourseSummary {
  key: string;
  kind: 'class' | 'self-paced';
  id: string;
  title: string;
}
export interface ParentCourse {
  title: string;
  description: string;
  allowed_kinds: string[];
  lessons: Array<{
    id: string;
    title: string;
    focus: string | null;
    deliverable: string | null;
    state: 'open' | 'locked' | 'done';
    missions: Array<{
      id: string;
      title: string;
      content_md?: string | null;
      project: { id: string; status: string; kind?: string } | null;
    }>;
  }>;
}
export function parentCourseError(error: unknown, action: 'read' | 'start' = 'read'): string {
  if (error instanceof ApiError) {
    if (error.status === 401 || error.code === 'PARENT_REQUIRED')
      return 'Sign in to your parent account to continue. Your saved work stays in your account.';
    if (error.code === 'SELF_PACED_LESSON_LOCKED')
      return 'Finish the previous lesson before starting this task.';
    if (error.code === 'PARENT_COURSE_STUDIO_UNAVAILABLE')
      return 'This task does not use that workspace. Follow the lesson instructions with your child.';
    if (error.status === 403 || error.status === 404)
      return 'This course is not available to your parent account right now. Check your family booking or contact support. Do not pay again.';
  }
  return action === 'start'
    ? 'We could not open your task. Refresh this course to check for saved work before trying again.'
    : 'We could not load your course right now. Check your connection and try again. This does not mean your payment failed.';
}
